import React from "react";
import Header from "./header";
import Footer from "./footer";
import {
  App,
  Article,
  Section,
  Headline,
  Box,
  Image,
  Paragraph,
} from "grommet";
import portrait from "../img/portrait.png";
import SocialTwitter from "grommet/components/icons/base/SocialTwitter";
import SocialLinkedin from "grommet/components/icons/base/SocialLinkedin";
import SocialGithub from "grommet/components/icons/base/SocialGithub";

const Home = (props) => (
  <div>
    <Article full={true}>
      <Header page="home" />
      <Section pad="large" align="center" flex={true}>
        <Box flex="grow" />
        <Image src={portrait} size="large" />
        <Paragraph>
          Hi, I’m Adam. The site’s old, but a few things still hold up.
        </Paragraph>

        <Box flex="grow" />
        <Box direction="row" pad={{ between: "medium" }} responsive={false}>
          <a href="https://twitter.com/AdamAlexandr">
            <SocialTwitter />
          </a>
          <a href="https://github.com/Adam4lexander">
            <SocialGithub />
          </a>
        </Box>
      </Section>
    </Article>
    <Footer />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.js